'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _mediaButton = require('../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _appBadges = require('../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'product-hero';

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderMediaButton = function renderMediaButton(mediaButton, color) {
  if (mediaButton && mediaButton.text) {
    return _react2.default.createElement(
      _mediaButton2.default,
      {
        id: mediaButton.id,
        className: ORGANISM_NAME + '__mediabtn',
        color: color || mediaButton.color,
        fpti: 'PrdctHero-MediaBtn-' + (mediaButton.fpti || mediaButton.text),
        'data-video-id': mediaButton['data-video-id']
      },
      mediaButton.text
    );
  }
  return null;
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: 2, className: ORGANISM_NAME + '__headline' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderCta = function renderCta(cta, color) {
  if (cta && cta.text) {
    var targetValue = cta.target || '_self';
    return _react2.default.createElement(
      _button2.default,
      {
        id: cta.id,
        href: cta.href,
        color: color || cta.color || null,
        className: ORGANISM_NAME + '__cta',
        fpti: 'PrdctHero-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
        target: targetValue
      },
      cta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text pp-sans-small-regular' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var renderBadge = function renderBadge(content, clientInfo, isCentered) {
  var appBadgeContent = {
    clientInfo: clientInfo,
    ios: content.ios,
    android: content.android
  };
  var classes = isCentered ? ORGANISM_NAME + '__app-badge-wrapper--center' : ORGANISM_NAME + '__app-badge-wrapper';

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(_appBadges2.default, appBadgeContent)
  );
};

var ProductHero = function (_React$Component) {
  _inherits(ProductHero, _React$Component);

  function ProductHero(props) {
    _classCallCheck(this, ProductHero);

    var _this = _possibleConstructorReturn(this, (ProductHero.__proto__ || Object.getPrototypeOf(ProductHero)).call(this, props));

    _this.changeBackground = function (_ref) {
      var config = _ref.config,
          viewport = _ref.viewport;

      _this.setState({
        image: config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url)
      });
    };

    _this.renderParagraph = renderParagraph;
    _this.renderMediaButton = renderMediaButton;
    _this.renderHeadline = renderHeadline;
    _this.renderCta = renderCta;
    _this.renderHatchText = renderHatchText;
    _this.handleResize = _this.handleResize.bind(_this);
    _this.renderBadge = renderBadge;

    // if placeholder is not provided, the value of this.state.image
    // will be empty string, and background will be inherited from
    // the current theme.
    _this.state = {
      isMobile: false,
      image: _this.props.config.backgroundImage && _this.props.config.backgroundImage.placeholder
    };
    return _this;
  }

  _createClass(ProductHero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();

      // this method will only execute on the client side, after the
      // deferred JavaScript bundle is downloaded
      this.changeBackground(this.props);
    }

    // if the image URL changes then need to re-trigger setState

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.changeBackground(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    // changes the background image from placeholder to specified image

  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = Math.min(this.organismRef.ownerDocument.defaultView.innerWidth, this.organismRef.ownerDocument.documentElement.clientWidth, this.organismRef.ownerDocument.body.clientWidth);

      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          clientInfo = _props.clientInfo;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', className);
      var heroClasses = (0, _classnames2.default)('' + ORGANISM_NAME, className, theme);

      var belowHeroClasses = 'below-' + ORGANISM_NAME + ' theme-background-color-white';
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;

      // backgroundPosition always needs to be set otherwise backgroundImage will shift
      // when image loads
      var backgroundImageStyle = _extends({
        backgroundPosition: '' + (backgroundPosition || 'center')
      }, this.state.image && {
        position: 'absolute',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
        backgroundImage: 'url(' + this.state.image + ')',
        backgroundSize: 'cover',
        transition: 'all 1s linear',
        filter: this.state.image === config.backgroundImage.placeholder ? 'blur(15px)' : ''
      });

      var isCentered = config.deviceImageSize === 'large';

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          id: config.id ? config.id : null,
          'data-building-block': 'organism',
          className: sectionClasses
        },
        _react2.default.createElement(
          'div',
          { className: heroClasses, style: { position: 'relative' } },
          _react2.default.createElement('div', { style: backgroundImageStyle }),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-8 col-sm-12 ' + ORGANISM_NAME + '__container' },
                this.state.isMobile && paragraph && paragraph.text ? _react2.default.createElement(
                  'div',
                  null,
                  this.renderHeadline(headline)
                ) : _react2.default.createElement(
                  'div',
                  null,
                  this.renderHeadline(headline),
                  this.renderParagraph(paragraph),
                  this.renderMediaButton(mediaButton),
                  this.renderCta(primaryCta),
                  this.renderCta(secondaryCta),
                  this.renderBadge(content, clientInfo, isCentered),
                  this.renderHatchText(hatchText)
                )
              )
            )
          )
        ),
        this.state.isMobile && paragraph && paragraph.text && _react2.default.createElement(
          'div',
          { className: belowHeroClasses },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-lg-6 col-md-8 col-sm-12' },
                this.renderParagraph(paragraph),
                this.renderMediaButton(mediaButton, 'outline-blue'),
                this.renderCta(primaryCta),
                this.renderCta(secondaryCta, 'outline-blue'),
                this.renderBadge(content, clientInfo, isCentered),
                this.renderHatchText(hatchText)
              )
            )
          )
        )
      );
    }
  }]);

  return ProductHero;
}(_react2.default.Component);

exports.default = ProductHero;


ProductHero.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  viewport: _propTypes2.default.string,
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired,
      placeholder: _propTypes2.default.string
    }).isRequired,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light', 'theme-new-money']),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      'data-video-id': _propTypes2.default.string.isRequired
    }),
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    secondaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

ProductHero.defaultProps = {
  viewport: 'dedicated',
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    id: '',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-small.jpg',
      placeholder: ''
    },
    theme: 'theme-background-image-dark',
    backgroundPosition: 'center'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast ' + 'with background image. 152 characters maximum.'
    },
    mediaButton: {
      id: '',
      text: '25 characters maximum',
      'data-video-id': 'lkz4GZgyb9o'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy',
      fpti: 'product-hero'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh',
      fpti: 'product-hero'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/product-hero/jsx/ProductHero.js
// module id = 1133
// module chunks = 4